import type { Variable, VariableType } from '@core/entities/Variable';
import type { VariableInput } from '@core/repositories/CollectionRepository';

export interface VariableResponse {
  id: string;
  key: string;
  value: string | null;
  type: VariableType;
  is_enabled: boolean;
  position: number;
}

export const toVariable = (payload: VariableResponse): Variable => ({
  id: payload.id,
  key: payload.key,
  value: payload.value,
  type: payload.type,
  isEnabled: payload.is_enabled,
  position: payload.position,
});

export const toVariableInputPayload = (variable: VariableInput) => ({
  key: variable.key,
  value: variable.value ?? null,
  type: variable.type ?? 'default',
  is_enabled: variable.isEnabled ?? true,
});
